import { ProductUtils } from '@wix/package-picker-shared';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { ProductCard } from './ProductCard/ProductCard';

export const ProductCards = () => {
  return (
    <ProductCardList.Default.Root>
      {({ products }) => {
        const sortedProducts = ProductUtils.sortProducts({ products });

          return sortedProducts.map((product) => {
            if (!product.productId) {
              return null;
            }

            return (
              <ProductCard
                key={product.productId}
                productId={product.productId}
              />
            );
          });
        }}
      </ProductCardList.Default.Root>
  );
};
